import { useEffect } from "react";
import { useNavigation } from "react-router-dom";
import { toast } from "react-toastify";

/** Past this, a wait is long enough that people start tapping again */
const SLOW_AFTER_MS = 4000;

const SLOW_TOAST_ID = "screen-opening-slow";

/**
 * A line along the top of the window while any screen is opening, for the links that don't show
 * their own spinner, and a toast once the wait is long. Only the startup code is precached, so
 * the first open of a screen after a release waits on its download.
 */
export const ScreenOpeningLine = () => {
    const opening = useNavigation().state === "loading";

    useEffect(() => {
        if (!opening) return;

        const timer = setTimeout(
            () => toast.info("Still opening. The connection is slow.", { toastId: SLOW_TOAST_ID, autoClose: false }),
            SLOW_AFTER_MS
        );

        return () => {
            clearTimeout(timer);
            toast.dismiss(SLOW_TOAST_ID);
        };
    }, [opening]);

    if (!opening) return null;

    return (
        <div
            role="progressbar"
            aria-label="Opening"
            className="opening-line fixed inset-x-0 top-[env(safe-area-inset-top)] z-[60] h-1 overflow-hidden bg-primary/20 pointer-events-none"
        />
    );
};
